/**
 * Theme. Dark is the design; light is a working mode for reading scanned pages in a
 * bright room. Three states, matching how the browser actually behaves: an explicit
 * choice is stamped on the root element, and "system" stamps nothing so
 * `prefers-color-scheme` decides.
 */
export type Theme = "dark" | "light" | "system";

const STORAGE_KEY = "alt.theme";

export function readTheme(): Theme {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored === "dark" || stored === "light" ? stored : "system";
  } catch {
    return "system";
  }
}

export function applyTheme(theme: Theme): void {
  const root = document.documentElement;
  if (theme === "system") root.removeAttribute("data-theme");
  else root.setAttribute("data-theme", theme);
  try {
    if (theme === "system") localStorage.removeItem(STORAGE_KEY);
    else localStorage.setItem(STORAGE_KEY, theme);
  } catch {
    /* the attribute is already set; persistence is the only thing lost */
  }
}

/** dark → light → system → dark. */
export function nextTheme(theme: Theme): Theme {
  return theme === "dark" ? "light" : theme === "light" ? "system" : "dark";
}
